import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const appleIntegrationService = {
    connectIntegration,
    disconnectIntegration,
    editProfile,
};

function connectIntegration() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/integrations/apple/authenticate`, requestOptions).then(handleResponse);
}

function disconnectIntegration() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/integrations/apple/revoke-access`, requestOptions).then(handleResponse);
}

function editProfile(locationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/apple:connect`, requestOptions).then(
        handleResponse,
    );
}
